import { type FC } from "react";
import ClearButton from "shared/components/ClearButton";
import Filter from "shared/components/Filter";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import SearchField from "shared/components/SearchField";
import { useDynamicTranslationPage } from "../../context";

const PageFilterBar: FC = () => {
  const {
    searchData,
    contentFilterData,
    contentItemFilterData,
    onClearFilters,
  } = useDynamicTranslationPage();

  return (
    <FlexCenter columnGap={"1rem"} marginBottom={"1rem"}>
      <SearchField placeholder="Search" {...searchData} />
      <Filter title="Content" {...contentFilterData} sortAlphabetically />
      <Filter
        title="Content item"
        {...contentItemFilterData}
        sortAlphabetically
      />
      {(contentFilterData.selectedValue.length > 0 ||
        contentItemFilterData.selectedValue.length > 0) && (
        <ClearButton onClearFilters={onClearFilters} />
      )}
    </FlexCenter>
  );
};

export default PageFilterBar;
